import { render, staticRenderFns } from "./Coach.vue?vue&type=template&id=64c62052&scoped=true"
import script from "./Coach.vue?vue&type=script&lang=js"
export * from "./Coach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c62052",
  null
  
)

export default component.exports